// extracted by mini-css-extract-plugin
export default {"wrapper":"dropdown-field_wrapper__F2DXP","label":"dropdown-field_label__osQLk"};